import React from "react";
import { motion } from "framer-motion";
import { STORE_LINKS } from "../../data/landing";

const GP_BADGE = `${process.env.PUBLIC_URL}/badge-google-play.png?v=2`;
const AS_BADGE = `${process.env.PUBLIC_URL}/badge-app-store.png?v=2`;

// Both badges are normalized to the same pixel height, so equal CSS height
// renders them as a clean, matched pair (no one bigger or smaller).
const HEIGHTS = {
  sm: "h-9",
  md: "h-11",
  lg: "h-[52px]",
  xl: "h-14 sm:h-[64px]",
  responsive: "h-10 sm:h-[52px]",
};

export const StoreButtons = ({
  align = "start",
  testidPrefix = "store",
  size = "md",
  onDownload,
  nowrap = false,
  stack = false,
}) => {
  const alignClass =
    align === "center"
      ? "justify-center"
      : align === "end"
      ? "justify-end"
      : "justify-start";

  const h = HEIGHTS[size] || HEIGHTS.md;
  const wrapClass = nowrap ? "flex-nowrap" : "flex-wrap";
  const dirClass = stack ? "flex-col items-center" : `${wrapClass} items-center`;

  const linkClass =
    "inline-flex items-center overflow-hidden rounded-xl transition-[transform,box-shadow] duration-300";
  const imgClass = `${h} w-auto block`;

  return (
    <div className={`flex ${dirClass} gap-3 sm:gap-4 ${alignClass}`}>
      <motion.a
        href={STORE_LINKS.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Hari Om Bol on Google Play"
        data-testid={`${testidPrefix}-google-play-btn`}
        onClick={onDownload}
        whileHover={{ y: -3 }}
        whileTap={{ scale: 0.97 }}
        className={linkClass}
      >
        <img src={GP_BADGE} alt="Get it on Google Play" className={imgClass} draggable={false} />
      </motion.a>

      <motion.a
        href={STORE_LINKS.appStore}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download Hari Om Bol on the App Store"
        data-testid={`${testidPrefix}-app-store-btn`}
        onClick={onDownload}
        whileHover={{ y: -3 }}
        whileTap={{ scale: 0.97 }}
        className={linkClass}
      >
        <img src={AS_BADGE} alt="Download on the App Store" className={imgClass} draggable={false} />
      </motion.a>
    </div>
  );
};

export default StoreButtons;
